import * as Yup from 'yup';

import { PROFILE_FIELD_OTHER_VALUE } from '@utils/backend-api/profileSettings';

interface FirstPartyData {
  isRequired: boolean;
  requiredMessage?: string;
}

export const autoCompleteField = ({ isRequired, requiredMessage }: FirstPartyData) =>
  Yup.object().shape({
    label: Yup.string(),
    value: isRequired ? Yup.string().required(requiredMessage) : Yup.string(),
  });

const firstPartyDataSchema = ({ isRequired = true }: FirstPartyData) => ({
  companySize: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  customIndustry: Yup.object().when('industry', (industry) => {
    return Yup.object().shape({
      label: Yup.string(),
      value: Yup.lazy((value) => {
        if (industry && industry.value === PROFILE_FIELD_OTHER_VALUE) {
          return typeof value === 'number'
            ? Yup.number().min(1, 'Please enter an industry')
            : Yup.string().required('Please enter an industry');
        }
        return Yup.mixed();
      }),
    });
  }),
  customJobFunction: Yup.object().when('jobFunction', (jobFunction) => {
    return Yup.object().shape({
      label: Yup.string(),
      value: Yup.lazy((value) => {
        if (jobFunction && jobFunction.value === PROFILE_FIELD_OTHER_VALUE) {
          return typeof value === 'number'
            ? Yup.number().min(1, 'Please enter a job function')
            : Yup.string().required('Please enter a job function');
        }
        return Yup.mixed();
      }),
    });
  }),
  customJobLevel: Yup.object().when('jobLevel', (jobLevel) => {
    return Yup.object().shape({
      label: Yup.string(),
      value: Yup.lazy((value) => {
        if (jobLevel && jobLevel.value === PROFILE_FIELD_OTHER_VALUE) {
          return typeof value === 'number'
            ? Yup.number().min(1, 'Please enter a job level')
            : Yup.string().required('Please enter a job level');
        }
        return Yup.mixed();
      }),
    });
  }),
  customSubIndustry: Yup.object().when('subIndustry', (subIndustry) => {
    return Yup.object().shape({
      label: Yup.string(),
      value: Yup.lazy((value) => {
        if (subIndustry && subIndustry.value === PROFILE_FIELD_OTHER_VALUE) {
          return typeof value === 'number'
            ? Yup.number().min(1, 'Please enter a sub industry')
            : Yup.string().required('Please enter a sub industry');
        }
        return Yup.mixed();
      }),
    });
  }),
  customSubJobFunction: Yup.object().when('subJobFunction', (subJobFunction) => {
    return Yup.object().shape({
      label: Yup.string(),
      value: Yup.lazy((value) => {
        if (subJobFunction && subJobFunction.value === PROFILE_FIELD_OTHER_VALUE) {
          return typeof value === 'number'
            ? Yup.number().min(1, 'Please enter a sub job function')
            : Yup.string().required('Please enter a sub job function');
        }
        return Yup.mixed();
      }),
    });
  }),
  industry: autoCompleteField({ isRequired, requiredMessage: 'Please select an industry' }),
  jobFunction: autoCompleteField({ isRequired, requiredMessage: 'Please select a job function' }),
  jobLevel: autoCompleteField({ isRequired, requiredMessage: 'Please select a job level' }),
  postalCode: Yup.string().min(5, 'Please enter a valid postal code'),
  subIndustry: autoCompleteField({ isRequired, requiredMessage: 'Please select a sub industry' }),
  subJobFunction: autoCompleteField({
    isRequired,
    requiredMessage: 'Please select a sub job function',
  }),
});

export default firstPartyDataSchema;
